import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=3a99b94d&scoped=true&"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelHeader.vue?vue&type=style&index=0&id=3a99b94d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99b94d",
  null
  
)

export default component.exports